import React from 'react';
import { ITranslateProps, translate } from '../../../mixins/translate';
import * as htmlHelper from '../../../utils/htmlHelper';
import { PanelHeader } from '../../elements';
import { Component } from '../../utils/Component';
import { NullableFormattedDate } from '../../utils/NullableFormattedDate';
import { NullableFormattedTime } from '../../utils/NullableFormattedTime';

interface IRemark {
    id: string;
    text: string;
    remarkedOn: Date;
    remarkedBy: string;
}

interface IRemarksProps extends ITranslateProps {
    remarks: IRemark[];
    remarkText: string;
    onChangeEditor: (value: string) => void;
    saveRemarkClicked: (event: any) => Promise<void>;
}

class Remarks extends Component<IRemarksProps> {
    public override render() {
        return (
            <>
                {/* Remarks */}
                <PanelHeader text={this.props.t('survey.internalRemark')} />
                <div className={this.props.remarks.length ? '' : 'hidden'}>
                    <div className="bg-light darker pn">
                        {this.props.remarks.map((remark) => (
                            <div className="pn mn" key={remark.id}>
                                <div className="talk-bubble tri-right left-in">
                                    <div className="talktext">
                                        <p>{htmlHelper.newLineToBreak(remark.text)}</p>
                                        <span className="fs11 text-muted-darke">
                                            {remark.remarkedBy} <NullableFormattedDate value={remark.remarkedOn} /> -{' '}
                                            <NullableFormattedTime value={remark.remarkedOn} />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="">
                    <div className="section ">
                        <label className="field prepend-icon ">
                            <textarea
                                className="gui-textarea"
                                placeholder={this.props.t('common.remark')}
                                name="remark"
                                value={this.props.remarkText}
                                onChange={(e) => this.props.onChangeEditor(e.target.value)}
                            />
                            <label htmlFor="remark " className="field-icon ">
                                <i className="fa fa-comments" />
                            </label>
                        </label>
                    </div>

                    <div className="text-right p12">
                        <a href="# " onClick={this.props.saveRemarkClicked.bind(this)} className="btn btn-primary btn-sm fw600 ">
                            <span className="fa fa-save pr5"></span> {this.props.t('common.saveItem', this.props.t('common.remark'))}
                        </a>
                    </div>
                </div>
            </>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default translate()(Remarks);
